export const AnalysisTypes = {
  TxTracker: 'txTracker',
  OralHygiene: 'oralHygiene',
  Aligners: 'aligners'
}

export const AnalysisThemes = {
  Optimal: 'optimal',
  Good: 'good',
  Fair: 'fair',
  PayAttention: 'payAttention',
  Aligners: 'aligners',
  Neutral: 'neutral'
}
